// extracted by mini-css-extract-plugin
export default {"container":"BasicScroll_container__vKLZk"};